export default "__VITE_ASSET__DfcrDWHq__"